export const FETCH_DETAILED_CYPRESS_COMMAND_LOGS_LOADING =
  "FETCH_DETAILED_CYPRESS_COMMAND_LOGS_LOADING";
export const FETCH_DETAILED_CYPRESS_COMMAND_LOGS_SUCCESS =
  "FETCH_DETAILED_CYPRESS_COMMAND_LOGS_SUCCESS";
export const FETCH_DETAILED_CYPRESS_COMMAND_LOGS_FAILED =
  "FETCH_DETAILED_CYPRESS_COMMAND_LOGS_FAILED";
export const CLEAR_DETAILED_CYPRESS_COMMAND_LOGS =
  "CLEAR_DETAILED_CYPRESS_COMMAND_LOGS";
